import React from 'react'
import { compose } from 'redux'

import config from '../../config'
import { withModal } from '../modal/withModal'
import withPortalId from '../portal/withPortalId'
import ImageUploadEditModal from './ImageUploadEditModal'
import withReloadableURL from './withReloadableURL'
import styledComponents from 'styled-components'

const ImageUpload = ({ source, showModal, onReloadURL, ...props }) => (
  <CardLayout>
    <div className="card-image">
      {props.value && (
        <figure className="image">
          <img src={source} alt={props.value} />
        </figure>
      )}
    </div>
    <footer className="card-footer">
      <UploadBtnWithModal
        {...props}
        onUpload={showModal}
        onReloadImage={onReloadURL}
      />
    </footer>
  </CardLayout>
)

const CardLayout = styledComponents.div.attrs({
  className: 'card',
})`
  max-width: 145px !important;
`

const UploadBtn = ({ showModal }) => (
  <a className="card-footer-item" onClick={showModal}>
    <strong>Upload</strong>
  </a>
)
const UploadBtnWithModal = withModal(ImageUploadEditModal, {
  props: ownProps => ({
    portalId: ownProps.portalId,
    currentImageId: ownProps.value,
    onReloadImage: ownProps.onReloadImage,
    imageAspectRatio: 1,
    longerWidth: 900
    // linkIndex: ownProps.itemIndex,
  }),
})(UploadBtn)

export default compose(
  withPortalId,
  withReloadableURL(props => ({
    originalURL: config.imageURLPrefix + '/' + props.value,
  })),
)(ImageUpload)



// WEBPACK FOOTER //
// ./src/modules/image/ImageUpload.js